import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { FlightModel } from "@/_models/flight/flight.model";
import { Issue } from "@/_models/issue.interface";
import { Promotion } from "@/_models/promotion.interface";
import { Task } from "@/_models/task.interface";
import { SharedComponentsModule } from "../../shared-components.module";
import { DateUtils } from "@/_utility/DateTimeFormat";

@Component({
    selector: "app-combined-task-card-mobile",
    standalone: true,
    imports: [CommonModule, SharedComponentsModule],
    templateUrl: "./combined-task-card-mobile.component.html",
    styleUrls: ["./combined-task-card-mobile.component.scss"],
})
export class CombinedTaskCardMobileComponent {
    constructor(public dateUtils: DateUtils) {}
    @Input() data!: FlightModel | Issue | Promotion | Task;
    @Input() type: "flight" | "issue" | "promotion" | "task"; // Default type is 'flight'
    @Input() showEdit = false;

    isFlight(): boolean {
        return this.type === "flight";
    }

    isIssue(): boolean {
        return this.type === "issue";
    }

    isPromotion(): boolean {
        return this.type === "promotion";
    }

    isTask(): boolean {
        return this.type === "task";
    }

    getFormType(): string {
        if (this.isFlight()) {
            const formType = (this.data as FlightModel)?.assessment
                ?.formTypeSettings?.type;
            return formType === "generalForm" ? "general" : formType;
        } else if (this.isIssue()) {
            return "issue";
        } else if (this.isPromotion()) {
            return "promotion";
        } else if (this.isTask()) {
            return "task";
        }
        return "unknown";
    }

    getTotalAssociations(task: Task): number {
        const flightCount = task.relatedFlights?.length || 0;
        const issueCount = task.relatedIssues?.length || 0;
        return flightCount + issueCount;
    }

    getTaskDueDate(): Date | undefined {
        if (this.isTask()) {
            return (this.data as Task).dueDate;
        }
        return undefined;
    }

    getTaskTotalAssociations(): number {
        if (this.isTask()) {
            return this.getTotalAssociations(this.data as Task);
        }
        return 0;
    }

    hasTaskAssociations(): boolean {
        return this.getTaskTotalAssociations() > 0;
    }
}
